var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipNuts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM14.35 17.32C13.67 17.69 12.72 18.15 11.99 18.16C11.35 18.16 9.86 18.43 9.3 18.53C9.17 18.55 9.05 18.49 9.01 18.37C8.89 18.08 8.64 17.51 8.31 16.99C7.95 16.42 7.44 15.98 7.22 15.56C6.03 13.36 6.55 10.71 8.33 9.26C8.61 9.46 8.91 9.66 9.24 9.88C9.3 9.92 9.36 9.95 9.42 9.99C9.4 9.99 9.39 9.98 9.39 9.98C8.62 10.73 7.39 12.68 8.62 15.05C8.62 15.05 8.96 15.22 9.05 14.65C9.25 13.34 9.48 10.63 10.93 10.87C10.93 10.87 10.94 10.87 10.95 10.87C12.42 11.64 13.92 12.22 15.39 12.78C15.76 12.92 16.11 13.06 16.48 13.2C16.67 14.89 16 16.43 14.37 17.32H14.35ZM17.53 12.54C15.05 11.53 12.29 10.7 9.8 9.04C7.45 7.48 7.01 7.02 7.75 5.95C8.72 4.55 9.33 5.19 13.32 5.61C13.83 5.66 14.56 5.18 15.02 4.82C15.22 4.66 15.51 4.77 15.57 5.02C15.71 5.66 15.95 6.68 16.24 7.19C16.58 7.79 18.38 9.03 18.86 9.42C19.93 10.29 19.5 13.33 17.53 12.54Z",
    fill: "#973C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipNuts);
export default __webpack_public_path__ + "static/media/ic-chip-nuts.8cf457975583c24323dfdd4320c3bfe9.svg";
export { ForwardRef as ReactComponent };